export const endpoints = {
  USERS: "/user",
  BUILDING: "/building"
};
